import Customer from './customer';
import CustomerOrderRevision from './customer-order-revision';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { OrderStatus } from '../types';
import { LocalDate } from '../utils/local-date';

import type SiteMenuBeverageOrder from './site-menu-beverage-order';
import type SiteMenuOrder from './site-menu-order';
import type SiteMenuSupplyOrder from './site-menu-supply-order';

@JsonApiResource({
  type: 'customer-order',
})
export default class CustomerOrder extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) orderDate = new LocalDate().add(
    2,
    'day'
  );

  @JsonApiProperty({ type: 'string', readOnly: true }) latestRevisionId?: string;
  clonedOrderId?: number = undefined;
  clonedArchivedOrderId?: number = undefined;

  status: OrderStatus = OrderStatus.Submitted;
  siteNames?: string;
  siteNamesWithDisplayNumber?: string;
  @JsonApiRelationship('customer-order-revision') customerOrderRevisions?: CustomerOrderRevision[] =
    [];

  @JsonApiRelationship('customer-order-revision') latestRevision?: CustomerOrderRevision;

  @JsonApiRelationship('customer') customer = new Customer();
  @JsonApiRelationship('site-menu-beverage-order') siteMenuBeverageOrders: SiteMenuBeverageOrder[] =
    [];

  @JsonApiRelationship('site-menu-supply-order') siteMenuSupplyOrders: SiteMenuSupplyOrder[] = [];

  @JsonApiProperty({ type: 'object', readOnly: true })
  get siteMenuOrders(): SiteMenuOrder[] {
    return this.latestRevision?.siteMenuOrders ?? [];
  }
}
